import { Skeleton } from "@/components/ui/skeleton";
import { Inbox, AlertTriangle } from "lucide-react";

export const LoadingCards = ({ n = 4 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {Array.from({ length: n }).map((_, i) => <Skeleton key={i} className="h-32 rounded-xl" />)}
  </div>
);

export const LoadingBlock = ({ className = "h-64" }) => <Skeleton className={`w-full rounded-xl ${className}`} />;

export const EmptyState = ({ title = "Nothing here yet", hint, icon: Icon = Inbox, action }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed py-14 text-center">
    <Icon className="h-8 w-8 text-muted-foreground mb-3" />
    <p className="font-display text-lg">{title}</p>
    {hint && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const ErrorState = ({ message = "Could not load data." }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-sev-danger/30 bg-sev-danger/5 py-12 text-center">
    <AlertTriangle className="h-7 w-7 text-sev-danger mb-2" />
    <p className="text-sm text-sev-danger">{message}</p>
  </div>
);
